<script setup lang="ts">
  import { IconClose } from '@gat-ship/icons'
  import type { HTMLAttributes } from 'vue'
  import { cn } from '../../lib/utils'

  const props = defineProps<{
    class?: HTMLAttributes['class']
    label: string
  }>()

  const emit = defineEmits<{
    (e: 'click:delete'): void
    (e: 'click:item'): void
  }>()
</script>
<template>
  <div
    :class="
      cn(
        'bg-muted group flex h-8 cursor-pointer select-none items-center overflow-hidden rounded-sm transition-all',
        props.class
      )
    "
  >
    <div
      class="hover:bg-border flex h-full items-center gap-2 px-2"
      @click="emit('click:item')"
    >
      <slot name="icon" />
      <span
        class="text-muted-foreground group-hover:text-foreground pr-2 text-xs font-medium"
        >{{ label }}</span
      >
    </div>
    <div
      class="hover:bg-border flex h-full w-0 items-center justify-center overflow-hidden transition-all group-hover:w-8"
      @click="emit('click:delete')"
    >
      <icon-close class="size-3.5" />
    </div>
  </div>
</template>
